import React from 'react';
import { TableWrapper } from './TableWrapper';
interface MirroringTabProps {
  searchTerm: string;
}
export function MirroringTab({
  searchTerm
}: MirroringTabProps) {
  return <div className="bg-gray-50 p-6 rounded-xl shadow-md" data-id="element-477">
      <h2 className="text-3xl font-bold text-gray-800 mb-4 pb-3 border-b-4 border-purple-600" data-id="element-478">
        Mirroring & Imaging
      </h2>
      <div className="bg-white p-6 rounded-xl shadow-md mb-8" data-id="element-479">
        <p className="text-gray-700 leading-relaxed" data-id="element-480">
          Mirroring and imaging are powerful tools for selecting distal points.
          They allow us to use correspondences between different body parts to
          treat pain and dysfunction remotely.
        </p>
      </div>
      {/* Visual Overview - Front and Back Views */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8" data-id="element-481">
        <h3 className="text-2xl font-bold text-teal-700 mb-4" data-id="element-482">
          Anatomical Correspondences Overview
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-483">
          <div data-id="element-484">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ge7UEHtBFRdXxcf77mP9qc/image.png" alt="Direct anatomical correspondences between upper and lower limbs" className="w-full rounded-lg shadow-md" data-id="element-485" />
            <p className="text-sm text-gray-600 mt-2 text-center" data-id="element-486">
              Basic Limb Anatomy - Upper and Lower Correspondences
            </p>
          </div>
          <div data-id="element-487">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ttxGnb3hTeTW9A2RyWARok/image.png" alt="Direct mirror relationships with connecting lines" className="w-full rounded-lg shadow-md" data-id="element-488" />
            <p className="text-sm text-gray-600 mt-2 text-center" data-id="element-489">
              Direct Mirror - Anatomical Correspondences with Lines
            </p>
          </div>
        </div>
        <h4 className="text-xl font-semibold text-teal-600 mb-3" data-id="element-490">
          Back View Correspondences
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-491">
          <div data-id="element-492">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3f1CeNN2UXMKXRWC9EorD9/image.png" alt="Back view - anatomical correspondences between limbs" className="w-full rounded-lg shadow-md" data-id="element-493" />
            <p className="text-sm text-gray-600 mt-2 text-center" data-id="element-494">
              Posterior View - Shoulder to Hip, Elbow to Knee Correspondences
            </p>
          </div>
          <div data-id="element-495">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fUSF5LjaVjDRwBAt2hU7gf/image.png" alt="Back view - detailed limb correspondences" className="w-full rounded-lg shadow-md" data-id="element-496" />
            <p className="text-sm text-gray-600 mt-2 text-center" data-id="element-497">
              Posterior Mirroring - Complete Upper to Lower Limb Mapping
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-498">
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-499">
          <h3 className="text-xl font-bold text-teal-700 mb-3" data-id="element-500">
            Direct Mirror
          </h3>
          <p className="text-sm text-gray-600 mb-4" data-id="element-501">
            Simple anatomical correspondences
          </p>
          <div className="space-y-3" data-id="element-502">
            {[{
            from: 'Finger',
            to: 'Toe'
          }, {
            from: 'Hand',
            to: 'Foot'
          }, {
            from: 'Wrist',
            to: 'Ankle'
          }, {
            from: 'Forearm',
            to: 'Lower Leg'
          }, {
            from: 'Elbow',
            to: 'Knee'
          }, {
            from: 'Upper Arm',
            to: 'Thigh'
          }, {
            from: 'Shoulder',
            to: 'Hip'
          }].map((pair, index) => <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-503">
                <span className="font-semibold text-gray-800" data-id="element-504">{pair.from}</span>
                <span className="text-purple-600 font-bold" data-id="element-505">↔</span>
                <span className="font-semibold text-gray-800" data-id="element-506">{pair.to}</span>
              </div>)}
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-507">
          <h3 className="text-xl font-bold text-teal-700 mb-3" data-id="element-508">
            Reverse Mirror
          </h3>
          <p className="text-sm text-gray-600 mb-4" data-id="element-509">Inverted correspondences</p>
          <div className="space-y-3" data-id="element-510">
            {[{
            from: 'Finger',
            to: 'Top of Hip'
          }, {
            from: 'Hand',
            to: 'Hip'
          }, {
            from: 'Wrist',
            to: 'Hip Joint'
          }, {
            from: 'Forearm',
            to: 'Thigh'
          }, {
            from: 'Elbow',
            to: 'Knee'
          }, {
            from: 'Upper Arm',
            to: 'Lower Leg'
          }, {
            from: 'Shoulder',
            to: 'Ankle'
          }].map((pair, index) => <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-511">
                <span className="font-semibold text-gray-800" data-id="element-512">{pair.from}</span>
                <span className="text-purple-600 font-bold" data-id="element-513">↔</span>
                <span className="font-semibold text-gray-800" data-id="element-514">{pair.to}</span>
              </div>)}
          </div>
        </div>
      </div>
      <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-8" data-id="element-515">
        <strong className="text-blue-800" data-id="element-516">Clinical Application:</strong>
        <span className="text-blue-700" data-id="element-517">
          {' '}
          When treating shoulder pain, you can use direct mirror (treat hip area
          on opposite leg) or reverse mirror (treat ankle area on opposite leg).
          Palpate both areas and needle the more tender one.
        </span>
      </div>
      {/* Clinical Example with Points */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8" data-id="element-518">
        <h3 className="text-xl font-bold text-teal-700 mb-4" data-id="element-519">
          Dr Tan's Liv 8 & GB34 points location
        </h3>
        <div className="flex justify-center" data-id="element-520">
          <div className="max-w-2xl" data-id="element-521">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vfAhMZgsbv6D6FmALR9TgZ/image.png" alt="Knee pain treatment using mirroring - LR8T and GB34T points" className="w-full rounded-lg shadow-md" data-id="element-522" />
            <p className="text-sm text-gray-600 mt-3 text-center" data-id="element-523">
              For knee pain, use mirroring to treat the elbow area on the
              opposite arm. Points like GB34T (Gallbladder area) and LR8T (Liver
              area) on the elbow correspond to the knee.
            </p>
          </div>
        </div>
      </div>
      <h3 className="text-2xl font-bold text-gray-800 mb-6 mt-8" data-id="element-524">
        Imaging Formats
      </h3>
      {/* Head Imaging Section */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8" data-id="element-525">
        <h3 className="text-xl font-bold text-teal-700 mb-4" data-id="element-526">
          Head & Face Imaging
        </h3>
        <div className="flex justify-center mb-4" data-id="element-527">
          <div className="max-w-2xl" data-id="element-528">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/15RArGxXVcY64iE7Q6PXHQ/image.png" alt="Head and face correspondences to limbs" className="w-full rounded-lg shadow-md" data-id="element-529" />
            <p className="text-sm text-gray-600 mt-3 text-center" data-id="element-530">
              The head and face can be treated using limb correspondences. Upper
              limbs image to facial structures, lower limbs to cranial vault.
            </p>
          </div>
        </div>
        {/* Scalp Hologram Section */}
        <div className="mt-6 border-t pt-6" data-id="element-531">
          <h4 className="text-lg font-semibold text-teal-600 mb-4" data-id="element-532">
            Scalp Hologram Mapping
          </h4>
          <div className="flex justify-center mb-4" data-id="element-533">
            <div className="max-w-2xl" data-id="element-534">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mtzHS4nVC6A5Bun1uc3tVQ/image.png" alt="Scalp hologram showing body correspondences on the head" className="w-full rounded-lg shadow-md" data-id="element-535" />
              <p className="text-sm text-gray-600 mt-3 text-center" data-id="element-536">
                Scalp hologram demonstrates how the entire body maps onto the
                head. The inverted body image shows treatment zones for
                corresponding body areas.
              </p>
            </div>
          </div>
          <div className="bg-teal-50 p-4 rounded-lg" data-id="element-537">
            <h5 className="font-semibold text-teal-800 mb-2" data-id="element-538">
              Scalp Hologram Applications:
            </h5>
            <ul className="text-teal-700 space-y-1 text-sm" data-id="element-539">
              <li data-id="element-540">• Top of head corresponds to feet and lower body</li>
              <li data-id="element-541">• Sides of head correspond to upper and lower limbs</li>
              <li data-id="element-542">• Front of scalp corresponds to chest and abdomen</li>
              <li data-id="element-543">• Back of scalp corresponds to back and spine</li>
              <li data-id="element-544">
                • Treat scalp zones with needles or massage for distant body
                areas
              </li>
            </ul>
          </div>
        </div>
        <div className="bg-purple-50 p-4 rounded-lg mt-4" data-id="element-545">
          <h4 className="font-semibold text-purple-800 mb-2" data-id="element-546">
            Head Imaging Applications:
          </h4>
          <ul className="text-purple-700 space-y-1 text-sm" data-id="element-547">
            <li data-id="element-548">• Wrist area corresponds to jaw and TMJ</li>
            <li data-id="element-549">• Hand corresponds to face and sinuses</li>
            <li data-id="element-550">• Fingers correspond to eyes, nose, and mouth regions</li>
            <li data-id="element-551">• Ankle area corresponds to back of head/occiput</li>
            <li data-id="element-552">• Foot corresponds to top of cranium</li>
          </ul>
        </div>
      </div>
      {/* Governor Vessel Imaging */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8" data-id="element-553">
        <h3 className="text-xl font-bold text-teal-700 mb-4" data-id="element-554">
          Governor Vessel (Du Mai) Imaging
        </h3>
        <div className="flex justify-center mb-4" data-id="element-555">
          <div className="max-w-2xl" data-id="element-556">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8i86nXaXXr8qwADRWQJNrM/image.png" alt="Governor Vessel correspondences to spine" className="w-full rounded-lg shadow-md" data-id="element-557" />
            <p className="text-sm text-gray-600 mt-3 text-center" data-id="element-558">
              Governor Vessel points on the head correspond to different levels
              of the spine and trunk
            </p>
          </div>
        </div>
        <div className="bg-indigo-50 p-4 rounded-lg" data-id="element-559">
          <h4 className="font-semibold text-indigo-800 mb-3" data-id="element-560">
            Key Governor Vessel Correspondences:
          </h4>
          <div className="space-y-2 text-sm" data-id="element-561">
            <div className="flex items-center justify-between p-2 bg-white rounded" data-id="element-562">
              <span className="font-semibold text-indigo-900" data-id="element-563">
                Du-16 (Fengfu)
              </span>
              <span className="text-indigo-600" data-id="element-564">→</span>
              <span className="text-indigo-800" data-id="element-565">Tailbone/Coccyx</span>
            </div>
            <div className="flex items-center justify-between p-2 bg-white rounded" data-id="element-566">
              <span className="font-semibold text-indigo-900" data-id="element-567">
                Du-18 (Qiangjian)
              </span>
              <span className="text-indigo-600" data-id="element-568">→</span>
              <span className="text-indigo-800" data-id="element-569">Sacral Area</span>
            </div>
            <div className="flex items-center justify-between p-2 bg-white rounded" data-id="element-570">
              <span className="font-semibold text-indigo-900" data-id="element-571">
                Du-20 (Baihui)
              </span>
              <span className="text-indigo-600" data-id="element-572">→</span>
              <span className="text-indigo-800" data-id="element-573">L2 (Waist Level)</span>
            </div>
            <div className="flex items-center justify-between p-2 bg-white rounded" data-id="element-574">
              <span className="font-semibold text-indigo-900" data-id="element-575">
                Du-22 (Xinhui)
              </span>
              <span className="text-indigo-600" data-id="element-576">→</span>
              <span className="text-indigo-800" data-id="element-577">Thoracic Vertebrae</span>
            </div>
            <div className="flex items-center justify-between p-2 bg-white rounded" data-id="element-578">
              <span className="font-semibold text-indigo-900" data-id="element-579">Hairline</span>
              <span className="text-indigo-600" data-id="element-580">→</span>
              <span className="text-indigo-800" data-id="element-581">C1-C2 (Upper Cervical)</span>
            </div>
          </div>
        </div>
      </div>
      {/* Limb to Trunk Imaging - Visual Guide */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8" data-id="element-582">
        <h3 className="text-xl font-bold text-teal-700 mb-4" data-id="element-583">
          Limb to Trunk Imaging - Visual Guide
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-584">
          <div data-id="element-585">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bUz8Rp34hEJC2de1xqn9tN/image.png" alt="Front view - limb to trunk correspondences" className="w-full rounded-lg shadow-md" data-id="element-586" />
            <p className="text-sm text-gray-600 mt-2 text-center font-semibold" data-id="element-587">
              Image Format (Front View)
            </p>
            <p className="text-xs text-gray-500 mt-1 text-center" data-id="element-588">
              Finger → Lower body, Shoulder → Upper body
            </p>
          </div>
          <div data-id="element-589">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5kueuhwSUQsuH9Ncp6xDYi/image.png" alt="Back view - limb to trunk correspondences" className="w-full rounded-lg shadow-md" data-id="element-590" />
            <p className="text-sm text-gray-600 mt-2 text-center font-semibold" data-id="element-591">
              Image Format (Back View)
            </p>
            <p className="text-xs text-gray-500 mt-1 text-center" data-id="element-592">
              Same principles apply from posterior view
            </p>
          </div>
          <div data-id="element-593">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/f94qJXZpzLcJQxr4YSnJd3/image.png" alt="Reverse format - limb to trunk correspondences" className="w-full rounded-lg shadow-md" data-id="element-594" />
            <p className="text-sm text-gray-600 mt-2 text-center font-semibold" data-id="element-595">
              Reverse Format (Front View)
            </p>
            <p className="text-xs text-gray-500 mt-1 text-center" data-id="element-596">
              Finger → Upper body, Shoulder → Lower body
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-597">
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-598">
          <h3 className="text-xl font-bold text-teal-700 mb-3" data-id="element-599">
            Upper Limb to Trunk - Image Format
          </h3>
          <p className="text-sm text-gray-600 mb-4" data-id="element-600">
            Limb tip = lower body, shoulder = upper body
          </p>
          <div className="space-y-3" data-id="element-601">
            {[{
            from: 'Finger',
            to: 'Testicles/Anus'
          }, {
            from: 'Hand',
            to: 'Genitals/Sacrum'
          }, {
            from: 'Wrist',
            to: 'Lumbo-sacral area'
          }, {
            from: 'Forearm',
            to: 'Lower abdomen/back'
          }, {
            from: 'Elbow',
            to: 'L2/Waistline'
          }, {
            from: 'Upper Arm',
            to: 'Chest'
          }, {
            from: 'Shoulder',
            to: 'Neck/base of skull'
          }].map((pair, index) => <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-602">
                <span className="font-semibold text-gray-800" data-id="element-603">{pair.from}</span>
                <span className="text-purple-600 font-bold" data-id="element-604">→</span>
                <span className="font-semibold text-gray-800" data-id="element-605">{pair.to}</span>
              </div>)}
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-606">
          <h3 className="text-xl font-bold text-teal-700 mb-3" data-id="element-607">
            Upper Limb to Trunk - Reverse Format
          </h3>
          <p className="text-sm text-gray-600 mb-4" data-id="element-608">
            Limb tip = upper body, shoulder = lower body
          </p>
          <div className="space-y-3" data-id="element-609">
            {[{
            from: 'Finger',
            to: 'Top of Head'
          }, {
            from: 'Hand',
            to: 'Head'
          }, {
            from: 'Wrist',
            to: 'Neck'
          }, {
            from: 'Forearm',
            to: 'Chest'
          }, {
            from: 'Elbow',
            to: 'L2/Waistline'
          }, {
            from: 'Upper Arm',
            to: 'Lower abdomen'
          }, {
            from: 'Shoulder',
            to: 'Sacrum'
          }].map((pair, index) => <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-610">
                <span className="font-semibold text-gray-800" data-id="element-611">{pair.from}</span>
                <span className="text-purple-600 font-bold" data-id="element-612">→</span>
                <span className="font-semibold text-gray-800" data-id="element-613">{pair.to}</span>
              </div>)}
          </div>
        </div>
      </div>
      <div className="bg-green-50 border-l-4 border-green-500 p-4 mt-8" data-id="element-614">
        <strong className="text-green-800" data-id="element-615">Using Imaging:</strong>
        <ul className="mt-2 space-y-1 text-green-700" data-id="element-616">
          <li data-id="element-617">
            <strong data-id="element-618">Image Format:</strong> Treat upper limbs for lower body
            problems (shoulder for neck, hand for sacrum)
          </li>
          <li data-id="element-619">
            <strong data-id="element-620">Reverse Format:</strong> Treat upper limbs for upper body
            problems (hand for head, shoulder for sacrum)
          </li>
          <li data-id="element-621">
            <strong data-id="element-622">Lower Limb:</strong> Can use similar image/reverse imaging
            with legs (ankle = wrist, knee = elbow, etc.)
          </li>
          <li data-id="element-623">
            <strong data-id="element-624">Clinical Tip:</strong> Palpate corresponding areas on limbs
            and needle the most tender ashi points
          </li>
        </ul>
      </div>
    </div>;
}